import lodashGet from 'lodash/get';

// fichier permettant de construire des requêtes wms,wfs,...
const requestHelper = {

    ///////////////////////////////////////////////////////////////////////////
    // fonction permettant de récupérer l'url wfs suivant le centre de la carte
    ///////////////////////////////////////////////////////////////////////////
    getWfsUrlUsingCenterOfMap(urlBase,point,maxcc = 0) {
        if(!urlBase && !point && (maxcc && maxcc >= 0 && maxcc <= 100)) return null;

        let tileName = 'S2.TILE';
        let maxFeatures = 100; // defaut
        
        // ↓↓ Le but est de créer un bbox depuis un point => on va créer un bbox avec des côtés de 1mètre ↓↓
        let bbox = `${point.x},${point.y},${point.x+1},${point.y+1}`;

        return `${urlBase.replace('wms', 'wfs')}?service=WFS&version=2.0.0&request=GetFeature&typenames=${tileName}&maxfeatures=${maxFeatures}&srsname=EPSG:3857&maxcc=${maxcc}&bbox=${bbox}&outputformat=application/json`;
    },

    ///////////////////////////////////////////////////////////////////////////
    // fonction permettant de récupérer la date la plus récente depuis la réponse d'un appel url WFS
    // L'objet Date plutôt que moment() est utilisé à cause du module react-datePicker 2.0.0
    ///////////////////////////////////////////////////////////////////////////
    getRecentDateFromWfsResponse(wfsResponse = null){
        var date = null;
        if (wfsResponse && wfsResponse.features && (wfsResponse.features.length > 0)) {
                try {
                let value = wfsResponse.features[0].properties.date;
                date = new Date(value);//moment(value,["MM-DD-YYYY", "YYYY-MM-DD"]);
            }
            catch(error) {
                date = new Date();//moment();
            }
        }

        return date;
    },

    /**
     * Si l'erreur est de type http, on la traite avec un handler personnalisé
     * @param {object} err erreur renvoyé par requestWithAuthent
     * @param {Object<number, () => void>} customHttpHandler 
     */
    handleRequestHttpError(err, customHttpHandler = {}) {

        const status = lodashGet(err, `response.status`, null);

        if (status && customHttpHandler[status]) {
            customHttpHandler[status](err);
        }
    },

    /**
     * Si l'erreur est de type aborted, on la traite avec un handler personnalisé
     * @param {object} err erreur renvoyé par requestWithAuthent
     * @param {() => void} handler  
     */
    onAbortError(err ,handler) {
        if (err?.name === 'AbortError') {
            handler();
        } else {
            return;
        }
    }
};


export default requestHelper;